import React, { useContext, useState, useRef, useMemo } from "react";
import { IconButton, Table, TableHead, TableBody, TableRow, TableCell, Paper, Menu, MenuItem, TableSortLabel, Tooltip, ButtonGroup, Box, } from "@mui/material";
import useTradeCell from "../../tablecells/Trade";
import { ThemeContext } from "../../../context/ThemeContext";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import CheckIcon from "@mui/icons-material/Check"
import { useTranslation } from "react-i18next";
import { closeOrderPosition, } from "../../../api/request/dashboard/dashboard";
import CloseIcon from "@mui/icons-material/Close";
import '../../../App.scss'
import toast from 'react-hot-toast';
import Checkbox from '@mui/material/Checkbox';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import Order from './order/Orders'
import { deletePositionsData } from "../../../store/Slices/orderPositionSlice";
import NoDataTable from "../../table/NoDataTable";
import { getCookies } from "../../../services/Cookies";
import TradeMenu from "../../../MobileView/components/TradeMenu";
import { CiMenuKebab } from "react-icons/ci";
import EditPositionModal from "../../modal/EditSLTP/EditPositionModal";
import AccountFooter from "../../footer/AccountFooter";
import FloatingProfitLoss from "../../global/BidAsk/FloatingProfitLoss";
import TotalCommission from "../../global/BidAsk/TotalCommission";

export default function Trade({ handleOpenModifyPositionModal, handleChartFromTradeTabClick }) {
  const { darkMode } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const [contextMenu, setContextMenu] = useState(null);
  const [submenuAnchor, setSubmenuAnchor] = useState(null);
  const { t } = useTranslation()
  const { accountId } = useSelector(state => state.accountSummary)
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const positions = useSelector((state) => state.orderPosition.positions, shallowEqual);
  const { symbols } = useSelector(state => state.watchlist)
  const clientId = getCookies("clientId");
  const componentName = 'Trade'
  const storageKey = `hiddenColumns_${clientId}_${componentName}`;
  const [editSLTPData, setEditSLTPData] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false)
  const [closingIds, setClosingIds] = useState([]);

  const orderSLTP = useSelector(state => state.orderPosition.orderSLTP);

  const handleEditSLTP = (row) => {
    const filteredSLTPs = orderSLTP.filter(sltp => sltp.positionId === row.id);
    setEditModalOpen(true)
    setEditSLTPData(filteredSLTPs);
  };



  const handleCloseModal = () => {
    setEditModalOpen(false);
    setEditSLTPData(null);
  };
  const TradeCell = useTradeCell(handleEditSLTP)

  const handleContextMenu = (event, row) => {
    event.preventDefault();
    setContextMenu({
      mouseX: event.clientX + 2,
      mouseY: event.clientY - 6,
      row,
    });
  };

  const handleCloseContextMenu = (event) => {
    // event.preventDefault();
    setContextMenu(null);
    setSubmenuAnchor(null);
  };

  const toggleColumnVisibility = (dataIndex) => {
    setVisibleColumns((prev) => {
      // const updatedColumns = { ...prev, [title]: !prev[title] };
      const updatedColumns = { ...prev, [dataIndex]: !prev[dataIndex] };


      const hiddenColumns = Object.keys(updatedColumns).filter(col => !updatedColumns[col]);
      localStorage.setItem(storageKey, JSON.stringify(hiddenColumns));

      return updatedColumns;
    });
  };

  const handleCloseClick = async (rowIndex = null, orderId = null) => {
    const ordersToClose = orderId
      ? [orderId]
      : rowIndex !== null
        ? [positions[rowIndex]?.id]
        : selectedRows;

    if (ordersToClose.length === 0) {
      toast.error("No trades selected");
      return;
    }

    setClosingIds(prev => [...new Set([...prev, ...ordersToClose])]);

    const closeRequests = ordersToClose.map(async (orderId) => {
      const selectedRow = positions.find(row => row.id === orderId);
      if (!selectedRow) return { success: false, positionId: orderId };

      const closeOrderPayload = {
        accountId: Number(accountId),
        positionId: selectedRow.id,
        amount: selectedRow.amount,
      };

      try {
        const response = await closeOrderPosition(closeOrderPayload);
        if (response.status === 200) {
          dispatch(deletePositionsData(orderId));
          return { success: true, positionId: orderId, position: selectedRow,  message: response?.data?.message || "Unexpected server response", };
        }
      } catch (error) {
        let apiMessage = "Unknown error";

        if (error?.response?.data?.message) {
          apiMessage = error.response.data.message;
        } else if (error?.message) {
          apiMessage = error.message;
        }
        console.error("Error closing order:", error);
              return { success: false, positionId: orderId, position: selectedRow, message: apiMessage, };

      }
    });

    const results = await Promise.allSettled(closeRequests);

    results.forEach(({ status, value }) => {
      if (status === "fulfilled" && value?.success) {
        const { positionId, position } = value;
        if (position) {
          const { symbolId, symbolName, side, profitLoss } = position;
          const price = side === 1 ? symbols[symbolId]?.bid : symbols[symbolId]?.ask;
          const tradeSide = side === 1 ? "Buy" : "Sell";

          toast.success(`Closed Trade #${positionId} (${symbolName}) at ${price}, ${tradeSide}, P/L ${profitLoss}`);
        }

      } else {
        const { positionId, position, message } = value || {};
        if (position) {
          const { symbolId, symbolName, side } = position;
          const price = side === 1 ? symbols[symbolId]?.bid : symbols[symbolId]?.ask;

          toast.error(`Failed to close Trade #${positionId} (${symbolName}) at ${price} due to: ${message || 'unknown error'}`);
        }
      }
    });

    setSelectedRows([]);
    selectedRowsRef.current = [];
    setForceUpdate(prev => !prev);
    setClosingIds(prev => prev.filter(id => !ordersToClose.includes(id))); // cleanup
    handleCloseContextMenu();
  };


  const getInitialVisibleColumns = () => {
    const storedHiddenColumns = JSON.parse(localStorage.getItem(storageKey));
    if (storedHiddenColumns) {
      return TradeCell.reduce((acc, col) => ({
        ...acc,
        [col.dataIndex]: !storedHiddenColumns.includes(col.dataIndex)

      }), {});
    }
    return TradeCell.reduce((acc, col) => ({ ...acc, [col.dataIndex]: true }), {});
  };
  const [visibleColumns, setVisibleColumns] = useState(getInitialVisibleColumns);

  const resetAllColumns = () => {
    const resetColumns = TradeCell.reduce((acc, col) => ({ ...acc, [col.dataIndex]: true }), {});
    setVisibleColumns(resetColumns);
    localStorage.removeItem(storageKey);
  }
  const sortTradeData = useMemo(() => {
    if (!Array.isArray(positions)) return [];

    return [...positions].sort((a, b) => {
      if (!sortConfig.key) return 0;
      const valueA = a[sortConfig.key];
      const valueB = b[sortConfig.key];

      if (typeof valueA === 'number' && typeof valueB === 'number') {
        return sortConfig.direction === 'asc' ? valueA - valueB : valueB - valueA;
      }
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return sortConfig.direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }
      return 0;
    });
  }, [positions, sortConfig]);



  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const handleToggleSearchBar = () => {
    setShowSearchBar((prev) => {
      if (prev) setSearchQuery("");
      return !prev;
    });
  };

  const filteredData = useMemo(() => {
    return sortTradeData.filter((row) =>
      TradeCell.some((col) => row[col.dataIndex]?.toString().toLowerCase().includes(searchQuery.toLowerCase()))
    );
  }, [sortTradeData, searchQuery]);

  const [selectedRows, setSelectedRows] = useState([]);
  const allSelected = selectedRows.length === filteredData.length && filteredData.length > 0;

  const handleRowSelect = (rowId) => {
    setSelectedRows((prev) => {
      const updated = prev.includes(rowId)
        ? prev.filter(id => id !== rowId)
        : [...prev, rowId];

      selectedRowsRef.current = updated;
      return updated;
    });
  };

  const handleSelectAll = () => {
    const newSelected = allSelected ? [] : [...filteredData.map(row => row.id)];
    setSelectedRows([...newSelected]);
  };

  const selectedRowsRef = useRef(new Set());
  const [forceUpdate, setForceUpdate] = useState(false);
  const totalInterest = filteredData.reduce((sum, item) => sum + (parseFloat(item.interest) || 0), 0);

  const totalAmount = filteredData.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
  const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);

  const fixedHeaderContent = () => {
    return <TableRow sx={{ borderTop: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, }} >
      <TableCell padding="checkbox" sx={{ borderBottom: "1px solid rgba(224, 224, 224, 0.3)", padding: "5px 5px", backgroundColor: darkMode ? "#151924" : "#fff", fontWeight: 700 }}>
        <ButtonGroup variant="outlined" sx={{ display: "flex", alignItems: "center", gap: 1, border: 'none' }}>
          <Tooltip title={t('selectall')}>
            <Checkbox checked={allSelected} onChange={handleSelectAll} indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length} sx={{ width: 24, height: 24, "& .MuiSvgIcon-root": { fontSize: 14 } }} />
          </Tooltip>
          <Tooltip title={t('delete')}>
            <span>
              <IconButton onClick={() => handleCloseClick(null, selectedRows.id)} sx={{ color: "red", width: 24, height: 24 }}><DeleteOutlinedIcon sx={{ fontSize: 14 }} /></IconButton>
            </span>
          </Tooltip>
        </ButtonGroup>
      </TableCell>
      {TradeCell.map(
        (col, index) => visibleColumns[col.dataIndex] && (
          <TableCell style={{ width: col?.width, fontWeight: 550, textTransform: "capitalize" }} key={index} sx={{ fontSize: "0.85rem", fontWeight: 200, p: 1, backgroundColor: darkMode ? "var(--background-color)" : "var(--white)", cursor: "pointer", borderBottom: "1px solid rgba(224, 224, 224, 0.3)", borderRight: `1px solid ${darkMode ? "#444" : "var(--borderLight)"}`, }} onClick={() => handleSort(col.dataIndex)}>
            <TableSortLabel active={sortConfig.key === col.dataIndex} direction={sortConfig.direction === 'asc' ? 'desc' : 'asc'}>
              {col.title}
            </TableSortLabel>
          </TableCell>
        )
      )}
      <TableCell style={{ width: 50 }} sx={{ borderBottom: "1px solid rgba(224, 224, 224, 0.3)", padding: "5px 5px", backgroundColor: darkMode ? "#151924" : "#fff", fontWeight: 700 }}>{t('actions')}</TableCell>
    </TableRow>
  }

  return (
    <>
      {/* <Paper style={{ width: "100%", position: 'relative', height: filteredData.length > 0 ? "calc(100vh - 30px)" : "auto", }}> */}
      <div className="flex flex-col" >
        <Paper style={{ width: "100%", height: "100%", flex: 1, }}>
          {/* <div style={{ position: "absolute", top: '3%', left: '1.4%', zIndex: 1000, display: "flex", alignItems: "center", transition: "width 0.4s ease-in-out", }}>
          {!showSearchBar && (
            <IconButton onClick={handleToggleSearchBar} sx={{ color: 'var(--primary)', borderRadius: "50%", transition: "opacity 0.3s ease-in-out", }}>
              <BiSearchAlt2 style={{ fontSize: 13.5 }} />
            </IconButton>
          )}
          {showSearchBar && (
            <Paper sx={{ display: "flex", alignItems: "center", borderRadius: 50, width: "250px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", marginLeft: "8px", padding: "2px", transition: "all 0.3s ease-in-out", backgroundColor: darkMode ? "#202933" : "#d5d5d5" }}>
              <TextField name="searchQuery" size="small" variant="outlined" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ "& fieldset": { border: "none" }, flex: 1, p: 0, height: 30, }}
                InputProps={{ sx: {fontSize: 13, padding: 0, height: 30, "& input": { padding: "0", paddingLeft: 1, height: "30px", }, }, }} />
              <IconButton onClick={handleToggleSearchBar}><CloseIcon sx={{ fontSize: 14 }} /></IconButton>
            </Paper>
          )}
        </div> */}
          {filteredData.length === 0 ? (<NoDataTable columns={TradeCell} data={filteredData} noDataMessage={t('noData')} />
          ) : (
            <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff", height: '100%', }}>
              <Table sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }}>
                <TableHead>
                  {fixedHeaderContent()}
                </TableHead>
                <TableBody>
                  {filteredData.map((row, index) => (
                    <TableRow key={row.id} onContextMenu={(event) => handleContextMenu(event, row)} sx={{ '&:hover .tradeRow': { backgroundColor: darkMode ? '#1f2635' : '#f5f5f5', }, }}>
                      <TableCell className="tradeRow" padding="checkbox" sx={{ border: 'none', padding: "5px", backgroundColor: darkMode ? "#151924" : "#fff", }}>
                        <Checkbox checked={selectedRows.includes(row.id)} onChange={() => handleRowSelect(row.id)} sx={{ width: 24, height: 24, "& .MuiSvgIcon-root": { fontSize: 12 }, }} />
                      </TableCell>

                      {TradeCell.filter(col => visibleColumns[col.dataIndex]).map((col, colIndex) => (
                        <TableCell className="tradeRow" key={`${row.id}-${colIndex}`} selected={selectedRows.includes(row.id)} sx={{ fontSize: "0.8rem", border: 'none', padding: "5px 5px", backgroundColor: darkMode ? "#151924" : "#fff", position: "relative", overflow: 'hidden', }}>
                          {col.render(row[col.dataIndex], row)}
                        </TableCell>
                      ))}

                      <TableCell className="tradeRow" sx={{ width: 24, border: 'none', padding: "5px 5px", backgroundColor: darkMode ? "#151924" : "#fff", }}>
                        <Box display='flex' >
                          <Tooltip title={t('moreAction')} arrow>
                            <IconButton size="small" sx={{ backgroundColor: darkMode ? "#151924" : "#fff" }} onClick={(event) => handleContextMenu(event, row)} >
                              <CiMenuKebab style={{ fontSize: 15 }} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title={t('cancel')} arrow>
                            <IconButton disabled={closingIds.includes(row.id)} className="closeTrade" size="small" sx={{ backgroundColor: darkMode ? "#151924" : "#fff" }} onClick={() => handleCloseClick(null, row.id)}>
                              <CloseIcon sx={{ fontSize: 15 }} />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow sx={{ backgroundColor: darkMode ? "#2b3543" : "var(--secondaryLight)" }}>
                    <TableCell sx={{ border: 'none', padding: "5px 5px", backgroundColor: darkMode ? "#2b3543" : "var(--secondaryLight)" }} />

                    {TradeCell.filter(col => visibleColumns[col.dataIndex]).map((col, colIndex) => {
                      const commonStyle = { padding: "5px 5px", fontWeight: 'bold', fontSize: '0.8rem', backgroundColor: darkMode ? "#2b3543" : "var(--secondaryLight)", color: darkMode ? 'var(--white)' : "var(--black)" };

                      switch (col.dataIndex) {
                        case "amount":
                          return (<TableCell key="total-amount" sx={{ ...commonStyle, }}>{totalAmount.toFixed(decimalPlaces)}</TableCell>);

                        case "commission":
                          return (<TableCell key="total-commission" sx={{ ...commonStyle, }}><TotalCommission /></TableCell>);

                        case "interest":
                          return (<TableCell key="total-interest" sx={{ ...commonStyle }}>{totalInterest.toFixed(2)}</TableCell>);

                        case "profit":
                          return (<TableCell key="total-profit" sx={{ ...commonStyle }}>{<FloatingProfitLoss />}</TableCell>);

                        default:
                          if (colIndex === 0) {
                            return (<TableCell colSpan={2} key={`pending-orders-${colIndex}`} sx={commonStyle}>{t('pendingOrders')}</TableCell>);
                          }

                          if (colIndex === 1) { return null; }
                          return (<TableCell key={`empty-${colIndex}`} sx={commonStyle} />);
                      }
                    })}

                    <TableCell sx={{ backgroundColor: darkMode ? "#2b3543" : "var(--secondaryLight)" }} />
                  </TableRow>
                </TableBody>
                <Order />
              </Table>
            </Box>
          )}
        </Paper>
        <div style={{ height: 35, position: "relative", zIndex: 99 }} ><AccountFooter searchQuery={searchQuery} setSearchQuery={setSearchQuery} /> </div>
        {/* <Box sx={{ p: 0, borderTop: `4px solid ${darkMode ? "var(--borderDark)" : "var(--borderLight)"}`, height: 30, width: '100%', position: 'absolute', bottom: 0, left: 0, backgroundColor: darkMode ? "#151924" : "#fff", zIndex: 1, }}><AccountFooter /></Box> */}
      </div>

      <Menu sx={{ "& .MuiList-root": { padding: 0 } }} open={contextMenu !== null} onClose={handleCloseContextMenu} anchorReference="anchorPosition" anchorPosition={contextMenu ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}>
        <TradeMenu handleOpenModifyPositionModal={handleOpenModifyPositionModal} handleChartFromTradeTabClick={handleChartFromTradeTabClick} contextMenu={contextMenu} setContextMenu={setContextMenu} style={{ fontSize: 13.5 }} showColumnsMenu={true} setSubmenuAnchor={setSubmenuAnchor} />
      </Menu>

      <Menu sx={{ "& .MuiList-root": { padding: 0 } }} open={Boolean(submenuAnchor)} anchorEl={submenuAnchor} onClose={handleCloseContextMenu} anchorOrigin={{ vertical: "top", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "left" }}>
        <div style={{ backgroundColor: darkMode ? "#262f3f" : "" }}>
          {TradeCell.filter(col => col.title !== `${t('symbol')}` && col.title !== `${t('P/L')}`).map((col, index) => (
            <MenuItem key={index} onClick={() => toggleColumnVisibility(col.dataIndex)} sx={{ fontSize: 13.5, display: "flex", justifyContent: "space-between", alignItems: "center", }}>
              {col.title} {visibleColumns[col.dataIndex] && (<CheckIcon sx={{ fontSize: 18, color: "#4597ff", }} />)}
            </MenuItem>))}

          <MenuItem onClick={resetAllColumns} sx={{ fontSize: 13.5, display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}` }}>{t('resetAll')}</MenuItem>
        </div>
      </Menu>
      {editModalOpen && (<EditPositionModal open={editModalOpen} handleClose={handleCloseModal} editSLTP={editSLTPData} />)}
    </>
  );
}